import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CategoryIpdModel } from '../../models'

export interface CategoryIpdState {
    Category: CategoryIpdModel
    CategoryList: CategoryIpdModel[]
}

const initialState: CategoryIpdState = {
    Category: {} as CategoryIpdModel,
    CategoryList: [],
}

export const CategoryIpdSlice = createSlice({
    name: 'category',
    initialState,
    reducers: {
        setCategories: (state, action: PayloadAction<CategoryIpdModel[]>) => {
            state.CategoryList = action.payload
        },
        saveCategory: (state, action: PayloadAction<CategoryIpdModel>) => {
            let category = action.payload
            if (category.Id > 0) {
                let defaultModel: CategoryIpdModel = { Id: 0, CategoryName: category.CategoryName, SingleSharingCharges:0,TwinSharingCharges:0,AttendantCharge:0}
                let currentCategory =
                    state.CategoryList.find((c) => c.Id === category.Id) || defaultModel
                currentCategory.CategoryName = category.CategoryName
            } else {
                category.Id = (Math.max(...state.CategoryList.map((c) => c.Id)) || 0) + 1
                state.CategoryList.push(category)
            }
        },
        getCategoryById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let category: CategoryIpdModel = {} as CategoryIpdModel
            if (id > 0) {
                let currentCategories: CategoryIpdModel[] = state.CategoryList
                category = currentCategories.find((c) => c.Id === id) || ({} as CategoryIpdModel)
            }

            state.Category = category
        },
        deleteCategories: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentCategories: CategoryIpdModel[] = state.CategoryList
                state.CategoryList = currentCategories.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setCategories, saveCategory, getCategoryById, deleteCategories } =
    CategoryIpdSlice.actions

export default CategoryIpdSlice.reducer
